import React from 'react';

const GamifikasiDesaEcoQuest: React.FC = () => {
  return (
    <div className="text-justify py-4 space-y-4">
      <p className="mb-4">
        Membangun website informatif tentang kelestarian lingkungan adalah langkah awal yang baik, namun mempertahankan minat dan partisipasi aktif pengguna dalam jangka panjang sering kali menjadi rintangan terbesar. Banyak platform sosial dan lingkungan yang mengalami penurunan pengguna secara drastis setelah beberapa minggu peluncuran karena minimnya interaktivitas dan umpan balik yang memotivasi.
      </p>

      <p className="mb-4">
        Untuk mengatasi fenomena kejenuhan ini, para pengembang web dalam kompetisi <b>EcoQuest Web Application</b> mengadopsi konsep <strong>gamifikasi (gamification)</strong> dan desain antarmuka pengguna (UI/UX) yang berpusat pada manusia (<i>Human-Centered Design</i>). Dengan menyisipkan mekanisme permainan ke dalam aksi lingkungan sehari-hari, kepedulian ekologis berubah dari tugas yang membosankan menjadi aktivitas yang seru dan memuaskan.
      </p>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Mekanisme Gamifikasi yang Menggerakkan Warga
      </h2>
      <p className="mb-4">
        Penerapan gamifikasi pada platform EcoQuest Village terbukti efektif dalam memicu dorongan psikologis positif (<i>positive reinforcement</i>) melalui beberapa modul fitur:
      </p>

      <ul className="list-disc pl-6 mb-6 space-y-3">
        <li>
          <strong>Tantangan Harian Hijau (Daily Eco-Quests):</strong> Memberikan misi terukur, seperti menyetor 1 kg sampah plastik ke bank sampah, mematikan peralatan listrik yang tidak terpakai, atau menanam bibit pohon di pekarangan rumah.
        </li>
        <li>
          <strong>Sistem Poin dan Lencana Prestasi (Badges & Eco-Points):</strong> Setiap misi yang diverifikasi akan memberikan poin yang dapat ditukarkan dengan voucher sembako desa atau diskon produk UMKM lokal, disertai lencana digital seperti <i>&quot;Green Pioneer&quot;</i>.
        </li>
        <li>
          <strong>Papan Peringkat Komunitas (Community Leaderboard):</strong> Menampilkan peringkat keaktifan antar-RT atau kelompok pemuda desa untuk memicu kompetisi positif yang mempererat kebersamaan.
        </li>
      </ul>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Sentuhan Desain UI/UX yang Nyaman dan Inklusif
      </h2>
      <p className="mb-4">
        Keberhasilan gamifikasi tidak dapat dipisahkan dari kualitas estetika dan kejelasan tata letak antarmuka. Penggunaan palet warna bernuansa alam, kartu komponen yang bersih, serta tipografi modern membuat tampilan web terasa segar dan menenangkan.
      </p>

      <p className="mb-4">
        Selain itu, penambahan <i>micro-animations</i> yang halus saat pengguna berhasil menyelesaikan misi memberikan kepuasan instan yang memperkuat kebiasaan hidup ramah lingkungan secara berkelanjutan.
      </p>
    </div>
  );
};

export default GamifikasiDesaEcoQuest;
